export const kiaFacebookUrl = 'https://www.facebook.com/KiaSouthAfrica';
export const kiaTwitterUrl = 'https://twitter.com/KiaSouthAfrica';
export const kiaLinkedinUrl = 'https://www.linkedin.com/company/2181867/';
export const frontendBaseUrl = 'https://www.kia.co.za';
export const kiaYouTubeUrl = 'https://www.youtube.com/user/KiaMotorsSA';
export const kiaTikTokUrl = 'https://www.tiktok.com/@kiasouthafrica/';
export const kiaInstagramUrl = 'https://www.instagram.com/kiasouthafrica/';
